<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row
          justify="center"
          align="center"
        >
          <v-col
            cols="12"
            md="6"
          >
            <sign-up-card />

            <v-row>
              <v-col cols="12">
                <span class="grey--text body-2">Already have an account?</span>
                <v-btn
                  class="primary--text"
                  small
                  text
                  rounded
                  :to="{ name: 'login' }"
                >
                  Log in here
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SignUpCard from "../components/SignUpCard"

export default {
  components: { SignUpCard }
}
</script>
